module.exports = __webpack_public_path__ + "img/07.54229e60.jpg";